export default {
  //代码里的key(唯一标识): '俄语',
  navigator: {

  },
  seo: {
    index: {

    },
    allPage: {

    },
    articles: {

    },
    download: {

    },
    search: {

    },
    contact: {

    }
  },
  globalTip: {

  },
  loginModule: {

  },
  toTop: {

  },
  indexPage: {

  },
  searchPage: {

  },
  filterPage: {

  },
  newsPage: {

  },
  downloadPage: {

  },
  detailPage: {
    vip: {
      dialog: {

      },
      player: {

      },
      episodes: {

      }
    }
  },
  playerModule: {

  },
  contact: {

  },
  download_nd: {

  },
  win: {
    feedback: {
      error: 'Ошибка системы'
    }
  },
  tv: {
    vip: {
      title: 'Пожалуйста, выберите ваш продукт',
      tip1: 'После входа в систему вы можете просмотреть QR-код для оплаты.',
      refresh: 'Обновить',
      tip2: 'Сканируйте QR-код для оплаты',
      recharge: 'Соглашение о пополнении',
      renewal: 'Соглашение о продлении',
      login: 'Войдите сейчас',
      tip3: 'Просмотр после входа в систему',
      noOpen: 'Стандартный VIP не активирован',
      gift: 'Подарок',
      succ: 'Обновление успешно',
      fail: 'Обновление не удалось',
      day: 'VIP стандарт 1 дн.',
      days: 'Стандартный VIP {x} д',
      expiration: 'Время истечения срока действия стандартного VIP: {x}',
      expired: 'Ваш VIP истек, пожалуйста, срочно продлите его.',
      interests1: 'Наслаждайтесь качеством HD 1080P',
      interests2: 'Разблокируйте весь контент',
      interests3: 'Вход на нескольких устройствах'
    }
  }
}